module.exports = __webpack_public_path__ + "img/dex_l2.cefb14e6.svg";